import React, { useMemo } from "react";
import PageSection from "../page-section";
import { useTranslation } from "react-i18next";
import PreferenceToggle from "../offline-responses/preference-toggle";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import FormMeta from "./form-meta";
import { Grid } from "@material-ui/core";
import "../style.css";
import AppLogger from "../../../utils/logger";
import SettingsDomain from "../../../features/settings";
import { getAuthUserAccount } from "../../../features/application";
import ActionFooter from "../action-footer";
import { setAppSnackNotification } from "../../../store/actions/application";
import { useState } from "react";

const AccountPreferences = () => {
  const { t } = useTranslation();
  const { authAccount } = useSelector((state) => state.application);
  const dispatch = useDispatch();

  const [isSubmittingData, setIsSubmittingData] = useState(false);

  const initalValues = useMemo(() => {
    return {
      [FormMeta.enableLastOnline.fieldName]:
        authAccount.userPreferences?.enableLastOnline ?? false,
    };
  }, [authAccount]);

  const onClickSave = async ({ values }) => {
    try {
      setIsSubmittingData(true);
      const preferences = {
        [FormMeta.enableLastOnline.fieldName]:
          values[FormMeta.enableLastOnline.fieldName],
      };

      const response = await SettingsDomain.updatePreferences({ preferences });
      if (response.success) {
        dispatch(getAuthUserAccount());
        dispatch(
          setAppSnackNotification({
            severity: "success",
            message: t("common.updatedsuccessfully"),
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppSnackNotification({
          severity: "error",
          message: t("message.unableToUpdatePreferences"),
        })
      );

      console.log("Error >>>", error);
      AppLogger.exception(error);
    } finally {
      setIsSubmittingData(false);
    }
  };

  return (
    <PageSection heading={t("settingPage.accountPreferences")}>
      <Formik
        initialValues={initalValues}
        enableReinitialize
        onSubmit={(values) => onClickSave({ values })}
      >
        {({ values, handleChange, dirty, resetForm, handleSubmit }) => (
          <Grid container direction="column" className="row-gap-16">
            <PreferenceToggle
              id={FormMeta.enableLastOnline.fieldName}
              label={t("settingPage.enableLastOnlineStatus")}
              value={values[FormMeta.enableLastOnline.fieldName]}
              handleChange={handleChange}
            />
            <ActionFooter
              onPrimaryAction={handleSubmit}
              onSecondaryAction={() => resetForm()}
              disablePrimary={!dirty}
              disableSecondary={!dirty}
              isLoading={isSubmittingData}
            />
          </Grid>
        )}
      </Formik>
    </PageSection>
  );
};

export default AccountPreferences;
